
import { h, Fragment } from 'preact'
import classnames from 'classnames'

export function FieldTextArea({ label, description, name, value, error, ...props }) {
	return <>
		<div class="textarea margin-y-3">
			<label>
				{label && <div class="textarea__label">{label}</div>}
				{description && <div>{description}</div>}
				<textarea name={name} {...props}>{value}</textarea>
			</label>
			{error && <div><span class="form-error">{error}</span></div>}
		</div>
	</>
}
